import { Badge } from "@/components/ui/badge";
import {
  ltx25SceneCount,
  type I2VProviderSummary,
} from "../experiments/providerExperimentTypes";

/**
 * "LTX local": the Echo's selected clips include self-hosted LTX-2.5
 * (`ltx25_comfy`), the real-estate i2v lane from 2026-10-04 (B2C stays on H3,
 * see H3LocalBadge). Rendered next to the H3 badge; nothing when no selected
 * clip came from LTX.
 */
export function LtxLocalBadge({
  summary,
  compact = false,
}: {
  summary?: I2VProviderSummary | null;
  compact?: boolean;
}) {
  const ltx = ltx25SceneCount(summary);
  if (!ltx) return null;
  const total = summary?.generated_scene_count ?? ltx;
  const fallback = Math.max(0, total - ltx);
  const detail = `${ltx}/${total} generated clips use LTX-2.5 (self-hosted)${fallback ? ` · ${fallback} other` : ""}`;
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5" title={detail}>
      <Badge
        variant="outline"
        className="border-teal-300 bg-teal-50 text-teal-800 dark:border-teal-700 dark:bg-teal-950 dark:text-teal-200"
      >
        LTX local
      </Badge>
      {!compact && (
        <span className="text-xs text-muted-foreground">{detail}</span>
      )}
    </span>
  );
}
